export {default} from './TipsSummary';
